import { render, staticRenderFns } from "./CrmLogo.vue?vue&type=template&id=4fe641e5&"
import script from "./CrmLogo.vue?vue&type=script&lang=js&"
export * from "./CrmLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports